import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FeeService } from '@app/services/fees/fee.service';
import { Subscription } from 'rxjs';
import { PermissionsService } from '@app/services/permissions/permissions.service';
import { SelectItem } from 'primeng/api';
import { ActivatedRoute } from '@angular/router';

interface IBaseinfo {
  idx: number;
  institutionId: number;
  institutionShortName: string;
  institutionName: string;
  year: number;
  isFullyPaid: boolean;
  totalPaidAmount: number;
  totalAmountToPay: number;
  balance: number;
  payments: IPayment[];
}

interface ITotalBalance {
  institutionId: number;
  institutionShortName: string;
  totalBalance: number;
}
interface IPayment {
  paidDate: string;
  paidAmount: number;
}

interface IInstitution {
  institutionId: number;
  institutionShortName: string;
}
@Component({
  selector: 'app-paidfees',
  templateUrl: './paidfees.component.html',
  styleUrls: ['./paidfees.component.css']
})
export class PaidfeesComponent implements OnInit, OnDestroy {
  @Input() roleid: number;
  memberid;
  paidfees: any[] = [];
  yearlist;
  subscriptions: Subscription[] = [];
  cols: any[];
  primepaidfees: any[] = [];
  expandedRows: any[] = [];
  ptablepaidfees: any[] = [];
  institutions: SelectItem[] = [];
  balanceinstitutions: IInstitution[] = [];
  yearFilter: number = 2011;
  yearTimeout: any;
  minyear;
  maxyear;

  constructor(
    private activatedRoute: ActivatedRoute,
    private feeService: FeeService,
    private permissionsService: PermissionsService) { }

  ngOnInit() {
    this.cols = [
      { field: 'year', header: 'År' },
      { field: 'institutionShortName', header: 'Institution' },
      { field: 'totalPaidAmount', header: 'Betalt totalt' },
      { field: 'totalAmountToPay', header: 'Årsavgift' },
      { field: 'balance', header: 'Saldo' },
      { field: 'isFullyPaid', header: 'Fullbetald' }
    ];
 
    this.activatedRoute.paramMap.subscribe(paramMap => {
      if(paramMap) {
      this.memberid = +paramMap.get('id');
      
      this.getPaidFees();
      }
    });
    this.permissionsService.getActiveRole().subscribe(resp => {
      if (resp) {
        this.roleid = resp;
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  getPaidFees() {

    
   const selectedroleid = +JSON.parse(sessionStorage.getItem('selectedrole')).roleId;

    this.feeService.GetMemberPaidFees(selectedroleid, this.memberid).subscribe(response => {
    
      if (response) {
       
        this.paidfees = response;
        this.createPTablePaidFees(this.paidfees);
      }
    });
  }

  createPTablePaidFees(paidfees) {
    this.balanceinstitutions = [];
    let years: any[] = [];
    let yearlist: any[] = [];
    years = this.DistinctRecords(paidfees, 'year');
    years.forEach(m => {
      yearlist.push(m.year);
    });
    this.yearlist = yearlist;
    this.yearlist.sort((a, b) => a - b);
    this.maxyear = yearlist[yearlist.length - 1];
    this.minyear = yearlist[0];
    this.yearFilter = this.minyear;
    let institutions: any[] = [];
    this.institutions = [{ label: '', value: '- Välj -' }];
    institutions = this.DistinctRecords(paidfees, 'institutionShortName');
    institutions.forEach(m => {
      const inst = {
        label: m.institutionShortName + ' ' + m.institutionName, value: m.institutionShortName
      };
      let balanceinstitution: IInstitution;
      balanceinstitution = { institutionId: m.institutionId, institutionShortName: m.institutionShortName };
      this.balanceinstitutions.push(balanceinstitution);
      this.institutions.push(inst);
    });

    let row: IBaseinfo[] = [];
    let yeardata;
    let idx = 0;
    paidfees.forEach(p => {
      idx++;
      yeardata = {
        idx: idx,
        institutionId: p.institutionId,
        institutionShortName: p.institutionShortName,
        institutionName: p.institutionName,
        year: p.year,
        isFullyPaid: p.isFullyPaid,
        totalAmountToPay: Math.round(p.totalAmountToPay),
        totalPaidAmount: Math.round(p.totalPaidAmount),
        payments: p.memberPayments,
        balance: Math.round(p.balance)
      };
      row.push(yeardata);
    });
    this.ptablepaidfees = row;
  }

  DistinctRecords(paidfees, prop) {
    return paidfees.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    })
  }

  onYearChange(event, dt) {
    if (this.yearTimeout) {
      clearTimeout(this.yearTimeout);
    }
    this.yearTimeout = setTimeout(() => {
      dt.filter(event.value, 'year', 'gte');
    }, 0);
  }

}
